export default "__VITE_ASSET__TpqkMJmx__"